import SurveyInfo from './SurveyInfo';

export default SurveyInfo;
